import type {
	ReferencedObjectAction,
	ReferencedObjectType,
} from '@repo/api-codegen';

export function getObjectTypeIcon(objectType: string) {
	switch (objectType) {
		case 'BI_METRIC':
			return 'chartLine';
		case 'BI_DASHBOARD':
			return 'customDashboard';
		case 'DOCUMENT':
			return 'file';
		default:
			return 'file';
	}
}

export function getObjectTypeLabel(objectType: ReferencedObjectType) {
	switch (objectType) {
		case 'BI_METRIC':
			return 'Metric';
		case 'BI_DASHBOARD':
			return 'Dashboard';
		case 'DOCUMENT':
			return 'Document';
		default:
			return objectType;
	}
}

export function getActionLabel(action: ReferencedObjectAction) {
	switch (action) {
		case 'CREATE':
			return 'created';
		case 'UPDATE':
			return 'updated';
		default:
			return action;
	}
}
